import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

export const ExportToExcel = async (columns: {[key: string]: number}, data: any[], sheetName: string, fileName: string, hypertextColumns: string[] | null = null) => {
    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    // Define the columns
    worksheet.columns = Object.entries(columns).map(([key, width])=> ({
        header: key,
        key: key,
        width: width,
        style: { 
            font: { size: 11, name: "Arial" },
            alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        },            
    }));

    // Add rows
    data.forEach(item => {
        worksheet.addRow(item);
    });
    
    // Apply formulas to the appropriate columns
    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1 && hypertextColumns) { // Skip the header row
            hypertextColumns.forEach(column=> {
                const cell = row.getCell(column);
                cell.font = { ...cell.font, underline: true, color: { theme: 10 } };
            })
        }
        row.eachCell({ includeEmpty: true }, (cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    // Generate Excel file buffer
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), fileName);

}